<section class="image-zoom-container">
    
    <!-- DIV BELOW IS USED TO DISPLAY ZOOMED PORTION OF THE IMAGE BELOW  -->
    <div #displayImgContainer class="image-container mb-4 mt-2">
        <img #displayImg
            (load)="onImageLoad(displayImg)"
            [src]="imgPath" 
            [style.width.px] = "displayImgWidth"
            [style.transform]="'translateX(' + imgPosition + 'px)'" 
            alt="...">
    </div>

    <!-- DIV BELOW IS WHAT THE END USER CLICKS AND SWIPES LEFT TO RIGHT --> 
    <app-draggable-box 
        (positionChanged)="UpdateImagePosition($event)" 
        [imgPath]="imgPath">
    </app-draggable-box>

</section>